import { render, staticRenderFns } from "./ficha.vue?vue&type=template&id=b390a628&scoped=true"
import script from "./ficha.vue?vue&type=script&lang=js"
export * from "./ficha.vue?vue&type=script&lang=js"
import style0 from "./ficha.vue?vue&type=style&index=0&id=b390a628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b390a628",
  null
  
)

export default component.exports